import React, { FunctionComponent, memo, useMemo, useCallback } from "react";
import { Flex } from "@chakra-ui/react";

import { TweenValue } from ".";
import { useIntl } from "react-intl";


interface IProps{
  name: string;
  unit: string;
  value: number;
  drift?: number;
  outOfBounds?: boolean;
}


const SourcePrimaryMetric: FunctionComponent<IProps> = memo(function SourcePrimaryMetric({
  name,
  unit,
  value,
  drift,
  outOfBounds,
}) {
  const intl = useIntl();
  const val = useMemo(() => value === null || value === undefined || typeof(value) === "number" ? value : value[1], [value]);

  const tooltip = useCallback((): string => {
    const lbl = name.replaceAll(/<[^>]+>/g, ""); // remove eventual HTML tags

    return `${lbl}: ${val} ${unit}`;
  }, [name, val, unit]);
  return <>
    <Flex
      flexDirection="row"
      justifyContent="flex-end"
    >
      {drift && <TweenValue
        signed
        round
        value={drift}
        fontSize="md"
        fontWeight="bold"
        color={outOfBounds ? "white" : drift && drift > 0 ? "green" : "red"}
        title={intl.formatMessage({
          id: "site__control__control_power_drift",
          defaultMessage: "Drift of the actual power from the target in kW",
        })}
      />}
      <TweenValue
        round
        value={value}
        fontSize={60}
        lineHeight={0.9}
        title={tooltip()}
      />
    </Flex>
  </>
});

export default SourcePrimaryMetric;
